import request from '@/plugins/axios'

// 员工管理接口
export const apiStaffLists = (params: any) => request.get('/staff.staff/lists', { params })

export const apiStaffDetail = (params: any) => request.get('/staff.staff/detail', { params })

export const apiStaffAvailableUsers = (params: any) => request.get('/staff.staff/availableUsers', { params })

export const apiStaffAdd = (data: any) => {
  return request({
    url: '/staff.staff/add',
    method: 'post',
    data
  })
}

export const apiStaffEdit = (data: any) => {
  return request({
    url: '/staff.staff/edit',
    method: 'post',
    data
  })
}

export const apiStaffDelete = (data: any) => {
  return request({
    url: '/staff.staff/delete',
    method: 'post',
    data
  })
}

export const apiStaffStatus = (data: any) => {
  return request({
    url: '/staff.staff/status',
    method: 'post',
    data
  })
}

export const apiStaffBlacklist = (data: any) => {
  return request({
    url: '/staff.staff/blacklist',
    method: 'post',
    data
  })
}

// 工种管理接口
export const apiWorkerTypeLists = (params: any) => request.get('/staff.workerType/lists', { params })

export const apiWorkerTypeDetail = (params: any) => request.get('/staff.workerType/detail', { params })

export const apiWorkerTypeAdd = (data: any) => {
  return request({
    url: '/staff.workerType/add',
    method: 'post',
    data
  })
}

export const apiWorkerTypeEdit = (data: any) => {
  return request({
    url: '/staff.workerType/edit',
    method: 'post',
    data
  })
}

export const apiWorkerTypeStatus = (data: any) => {
  return request({
    url: '/staff.workerType/status',
    method: 'post',
    data
  })
}

export const apiWorkerTypeDelete = (data: any) => {
  return request({
    url: '/staff.workerType/delete',
    method: 'post',
    data
  })
}

export const apiWorkerTypeList = (params?: any) => request.get('/staff.workerType/typeList', { params })

// 薪酬规则接口
export const apiSalaryRuleLists = (params: any) => request.get('/staff.salaryRule/lists', { params })

export const apiSalaryRuleDetail = (params: any) => request.get('/staff.salaryRule/detail', { params })

export const apiSalaryRuleAdd = (data: any) => {
  return request({
    url: '/staff.salaryRule/add',
    method: 'post',
    data
  })
}

export const apiSalaryRuleEdit = (data: any) => {
  return request({
    url: '/staff.salaryRule/edit',
    method: 'post',
    data
  })
}

export const apiSalaryRuleDelete = (data: any) => {
  return request({
    url: '/staff.salaryRule/delete',
    method: 'post',
    data
  })
}

export const apiSalaryRuleStatus = (data: any) => {
  return request({
    url: '/staff.salaryRule/status',
    method: 'post',
    data
  })
}

// 排班管理接口
export const apiScheduleLists = (params: any) => request.get('/staff.schedule/lists', { params })

export const apiScheduleDetail = (params: any) => request.get('/staff.schedule/detail', { params })

export const apiScheduleAdd = (data: any) => {
  return request({
    url: '/staff.schedule/add',
    method: 'post',
    data
  })
}

export const apiScheduleEdit = (data: any) => {
  return request({
    url: '/staff.schedule/edit',
    method: 'post',
    data
  })
}

export const apiScheduleDelete = (data: any) => {
  return request({
    url: '/staff.schedule/delete',
    method: 'post',
    data
  })
}

export const apiScheduleStatus = (data: any) => {
  return request({
    url: '/staff.schedule/status',
    method: 'post',
    data
  })
}

// 薪酬结算接口
export const apiSalarySettlementLists = (params: any) => request.get('/staff.salarySettlement/lists', { params })

export const apiSalarySettlementDetail = (params: any) => request.get('/staff.salarySettlement/detail', { params })

export const apiSalarySettlementConfirm = (data: any) => {
  return request({
    url: '/staff.salarySettlement/confirm',
    method: 'post',
    data
  })
}

export const apiSalarySettlementReview = (data: any) => {
  return request({
    url: '/staff.salarySettlement/review',
    method: 'post',
    data
  })
}

export const apiSalarySettlementPay = (data: any) => {
  return request({
    url: '/staff.salarySettlement/pay',
    method: 'post',
    data
  })
}

export const apiSalarySettlementGenerate = (data: any = {}) => {
  return request({
    url: '/staff.salarySettlement/generate',
    method: 'post',
    data
  })
}

// 转单记录接口
export const apiTransferRecordLists = (params: any) => request.get('/staff.transferRecord/lists', { params })

export const apiTransferRecordDetail = (params: any) => request.get('/staff.transferRecord/detail', { params })
